import React, { memo } from 'react';
import cn from 'classnames';

import { Link, Icon } from 'components';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './WelcomeContent.module.scss';

export interface WelcomeContentProps {
  /** Custom class name */
  className?: string;
  /** Custom style */
  style?: Record<string, unknown>;
  /** message */
  message: string;
  usertype: 'Recruiter' | 'Manager';
}

export const WelcomeContent: React.FC<WelcomeContentProps> = memo(
  ({
    className = '', // custom class name
    style, // custom style
    message,
    usertype,
  }: WelcomeContentProps) => {
    const contentClassNames = cn(styles.WelcomeContent, className);

    return (
      <section
        className={contentClassNames}
        style={style}
        data-testid="WelcomeContent"
      >
        <div className={styles.WelcomeContentIconContainer}>
          <Icon iconName="tick-mark" className={styles.WelcomeContentIcon} />
        </div>
        <h1 className={styles.WelcomeContentTitle}>
          👋 We are just setting up your account.
        </h1>
        <p className={styles.WelcomeContentDescription}>{message}</p>
        <Link
          variant="contained"
          color="primary-faint"
          href={
            usertype === 'Manager'
              ? PAGE_ROUTES.SIGN_IN_SOCIETY
              : PAGE_ROUTES.SIGN_IN_RECRUITER
          }
          className={styles.WelcomeContentCTA}
        >
          Sign in
        </Link>
      </section>
    );
  }
);

WelcomeContent.displayName = 'WelcomeContent';
